"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _comparisonTableEngine = _interopRequireDefault(require("./comparison-table-engine"));
var _vehicleCompare = _interopRequireDefault(require("../../styles/vehicle-compare.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var isSubOfGroup = function isSubOfGroup(_groupID, _parentGroupID) {
  return _groupID === _parentGroupID;
};
var getSubsOfGroup = function getSubsOfGroup(_groupID, _subGroups) {
  return _subGroups.filter(function (sub) {
    return isSubOfGroup(_groupID, sub.parentGroupID);
  });
};
var getTabNames = function getTabNames(specGroups) {
  return specGroups.map(function (group) {
    return group.sectionTitle;
  });
};
var isKeyFeature = function isKeyFeature(spec) {
  return spec.type === 'Key-Features' && spec;
};
var getAllKeyFeatures = function getAllKeyFeatures(_selectedModels) {
  return _selectedModels.map(function (model) {
    return model.detailedSpecifications.filter(isKeyFeature);
  });
};
var getAllModelsKeyFeaturesGroupedByLabel = function getAllModelsKeyFeaturesGroupedByLabel(_selectedModels
// _selectedVehicle,
) {
  var allKeyFeatures = getAllKeyFeatures(_selectedModels);
  var refinedKeyFeatures = [];
  _selectedModels.forEach(function (model, modelIndex) {
    refinedKeyFeatures.models = refinedKeyFeatures.models || [];
    refinedKeyFeatures.models[modelIndex] = {};
    // refinedKeyFeatures.models[modelIndex].selectedVehicle = _selectedVehicle;
    refinedKeyFeatures.models[modelIndex].model = model.name;
    refinedKeyFeatures.models[modelIndex].price = model.price;
  });
  allKeyFeatures.forEach(function (keyFeaturesArray, keyFeaturesIndex) {
    keyFeaturesArray.forEach(function (feature, featureIndex) {
      refinedKeyFeatures.specs = refinedKeyFeatures.specs || [];
      refinedKeyFeatures.specs[featureIndex] = refinedKeyFeatures.specs[featureIndex] || [];
      refinedKeyFeatures.specs[featureIndex][keyFeaturesIndex] = feature;
    });
  });
  return refinedKeyFeatures;
};
var getModelData = function getModelData(selectedModels, subGroup) {
  return selectedModels.map(function (model) {
    return {
      model: model.name,
      specs: model.detailedSpecifications.filter(function (spec) {
        return spec.type === subGroup.categoryID;
      })
    };
  });
};
var getAllModelsOtherFeaturesGroupedByLabel = function getAllModelsOtherFeaturesGroupedByLabel(_selectedModels, _specGroups, _subSpecGroups) {
  var subGroupsByGroup = _specGroups.map(function (group) {
    return getSubsOfGroup(group.groupID, _subSpecGroups);
  }).slice(1, _specGroups.length);
  subGroupsByGroup.forEach(function (groupOfSubgroups) {
    groupOfSubgroups.forEach(function (subGroup) {
      subGroup.selectedModels = getModelData(_selectedModels, subGroup);
      return subGroup;
    });
  });
  return subGroupsByGroup;
};
var createTableObject = function createTableObject(params) {
  var _groups = params._groups,
    _subGroups = params._subGroups,
    _selectedModels = params._selectedModels;
  return {
    // selectedVehicleObj: _selectedVehicleObj,
    // vehicle: _selectedVehicle,
    keyFeatures: getAllModelsKeyFeaturesGroupedByLabel(_selectedModels
    // _selectedVehicle,
    ),
    allOtherFeatures: getAllModelsOtherFeaturesGroupedByLabel(_selectedModels, _groups, _subGroups)
  };
};
var dataTransformation = function dataTransformation(params) {
  var _groups = params._groups,
    _subGroups = params._subGroups,
    _selectedModels = params._selectedModels;
  return {
    tabs: getTabNames(_groups),
    tables: createTableObject({
      _groups: _groups,
      _subGroups: _subGroups,
      _selectedModels: _selectedModels
      // _selectedVehicle,
      // _selectedVehicleObj,
    })
  };
};
var sectionNames = function sectionNames(tabsArray) {
  var returnSectionNames = [];
  for (var i = 0; i < tabsArray.length; i++) {
    returnSectionNames.push("section-" + (i + 1));
  }
  return returnSectionNames;
};
var _TABLE_DATA_ = null;
var ComparisonTable = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ComparisonTable, _React$Component);
  function ComparisonTable(props) {
    var _props$specificationG;
    var _this;
    _this = _React$Component.call(this, props) || this;
    var specificationGroupsCount = props == null ? void 0 : (_props$specificationG = props.specificationGroups) == null ? void 0 : _props$specificationG.length;
    var expandAllText = props.expandAllText;
    _this.state = {
      navInView: false,
      expandedAccordionList: [0],
      expandedAccordionToggleList: {
        expand: Array.from(Array(specificationGroupsCount).keys()),
        collapse: []
      },
      expandAccordionText: expandAllText
    };
    _this.onToggleAccordion = _this.onToggleAccordion.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onExitComparison = _this.onExitComparison.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onProgressComparison = _this.onProgressComparison.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = ComparisonTable.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var navInView = this.state.navInView;
    var models = this.props.models;
    if (navInView !== nextState.navInView) {
      return true;
    }
    var prevNumOfModelsSelected = 0;
    var thisNumOfModelsSelected = 0;
    models.forEach(function (model) {
      return model.selected && prevNumOfModelsSelected++;
    });
    nextProps.models.forEach(function (model) {
      return model.selected && thisNumOfModelsSelected++;
    });
    if (models) {
      var _this$props = this.props,
        specificationGroups = _this$props.specificationGroups,
        subSpecificationGroups = _this$props.subSpecificationGroups;
      // const selectedModels = getSelectedModels(nextModels);
      var selectedModels = nextProps.models;
      if (selectedModels.length) {
        var _data = dataTransformation({
          _groups: specificationGroups,
          _subGroups: subSpecificationGroups,
          _selectedModels: selectedModels
          // _selectedVehicle: nextProps.selectedVehicle,
          // _selectedVehicleObj: selectedVehicleObj,
        });
        _TABLE_DATA_ = _data;
      }
    }
    return true;
  };
  _proto.onExitComparison = function onExitComparison() {
    this.setState({
      navInView: false
    });
  };
  _proto.onToggleAccordion = function onToggleAccordion() {
    var _this$state = this.state,
      expandedAccordionList = _this$state.expandedAccordionList,
      expandedAccordionToggleList = _this$state.expandedAccordionToggleList;
    var _this$props2 = this.props,
      collapseAllText = _this$props2.collapseAllText,
      expandAllText = _this$props2.expandAllText;
    if (expandedAccordionList.length === 1) {
      // EXPAND
      this.setState({
        expandedAccordionList: expandedAccordionToggleList.expand,
        expandAccordionText: collapseAllText
      });
      return;
    }
    if (expandedAccordionList.length === 0) {
      this.setState({
        expandedAccordionList: expandedAccordionToggleList.expand,
        expandAccordionText: collapseAllText
      });
    } else {
      this.setState({
        expandedAccordionList: expandedAccordionToggleList.collapse,
        expandAccordionText: expandAllText
      });
    }
  };
  _proto.onProgressComparison = function onProgressComparison(scrollStatus) {
    var navInView = this.state.navInView;
    if (navInView && scrollStatus.progress < 0.01) {
      this.setState({
        navInView: false
      });
    } else if (navInView === false && scrollStatus.progress > 0.01) {
      this.setState({
        navInView: true
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      models = _this$props3.models,
      config = _this$props3.config,
      numberOfColumns = _this$props3.numberOfColumns,
      specificationGroups = _this$props3.specificationGroups;
    var modelLength = models.length;
    var _this$state2 = this.state,
      expandedAccordionList = _this$state2.expandedAccordionList,
      expandAccordionText = _this$state2.expandAccordionText;
    if (_TABLE_DATA_ !== null && models && models.length > 0) {
      var __TABLES__ = (0, _comparisonTableEngine["default"])({
        _tables: _TABLE_DATA_.tables,
        _styles: _vehicleCompare["default"],
        _theme: theme,
        _numberOfColumns: numberOfColumns,
        modelLength: modelLength,
        config: config,
        _tabs: _TABLE_DATA_.tabs,
        _scrollTabs: sectionNames(_TABLE_DATA_.tabs),
        expandedAccordionList: expandedAccordionList
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _vehicleCompare["default"].expandCollapseButtonContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-sm-10'] + " " + theme['col-sm-offset-1'] + " "
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: function onClick() {
          _this2.onToggleAccordion();
        },
        className: theme.textLinkUnderline + " "
      }, expandAccordionText))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _vehicleCompare["default"].tableTabsContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-sm-10'] + " " + theme['col-sm-offset-1'] + " " + _vehicleCompare["default"].noPadding + " " + _vehicleCompare["default"].addPixelLineBelow
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, __TABLES__))));
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-sm-10'] + " " + theme['col-sm-offset-1'] + " " + _vehicleCompare["default"].noPadding + " " + _vehicleCompare["default"].vehicleCompareNoModelContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _vehicleCompare["default"].expandCollapseButtonContainer
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      disabled: true,
      className: theme.textLinkUnderline + " " + _vehicleCompare["default"].accordionBtn + " "
    }, expandAccordionText)), specificationGroups.map(function (group) {
      return /*#__PURE__*/_react["default"].createElement("h3", {
        className: "" + theme.mmcIconChevronDown
      }, group.sectionTitle);
    })));
  };
  return ComparisonTable;
}(_react["default"].Component);
var _default = ComparisonTable;
exports["default"] = _default;